module.exports = __webpack_public_path__ + "img/arrow.045046ba.svg";